import ClearInputIcon from "notes-and-forms-v2/icons/ClearInputIcon";
import SignHereIcon from "notes-and-forms-v2/icons/SignHereIcon";
import { useState } from "react";
import { Button } from "react-bootstrap";
import { ElementViewProps } from "../atomic-element-view/AtomicElementView";
import styles from "./Initials.module.scss";
import getClasses from "utils/getClasses";

export default function Initials({
  signatureData = {},
  element,
  onSignatureChange,
  isLocked,
  isPrintMode,
  disabled,
  showAsMissing,
}: ElementViewProps<InitialsEnabledTemplateElement>) {
  const [isSigning, setIsSigning] = useState(false);
  const shouldShowInput = isSigning || signatureData.signature?.type === "text";

  if (isPrintMode || isLocked || disabled) {
    return (
      <div className={styles.container}>
        <div className={styles.signatureLineWrapper}>
          <div className={styles.signatureWrapper}>
            {signatureData.signature?.type === "text" && (
              <div className={styles.signatureInput}>
                {signatureData.signature?.type === "text"
                  ? signatureData.signature.value
                  : ""}
              </div>
            )}
          </div>
          <div className={styles.signatureLine} />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.signatureLineWrapper}>
        <div className={styles.signatureWrapper}>
          {shouldShowInput ? (
            <>
              <input
                className={styles.signatureInput}
                autoFocus={!signatureData.signature}
                value={
                  signatureData.signature?.type === "text"
                    ? signatureData.signature.value
                    : ""
                }
                onChange={(event) =>
                  onSignatureChange(element.id, {
                    dateSigned: new Date().toISOString(),
                    signature: {
                      type: "text",
                      value: event.target.value,
                    },
                  })
                }
              />
              <button
                className={styles.clearInputButton}
                onClick={() => {
                  setIsSigning(false);
                  onSignatureChange(element.id, {});
                }}
              >
                <ClearInputIcon />
              </button>
            </>
          ) : (
            <Button
              className={styles.signHereButton}
              onClick={() => setIsSigning(true)}
            >
              Initials <SignHereIcon />
            </Button>
          )}
        </div>
        <div
          className={getClasses(
            styles.signatureLine,
            showAsMissing && !signatureData.signature && styles.missing,
          )}
        />
      </div>
    </div>
  );
}
